import { useSelector } from "react-redux";
import { selectSequenceVariables } from "../../../app/slices/TrainingSlice";
import Interaction from "../../../models/interactions/Interaction";
import { VariableType } from "../../../models/interactions/Variable";
import { IGetTimerTime } from "../../../models/interactions/GetTimerTime";
import VariableSelector from "../variables/VariableSelector";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";

export default function GetTimerTimeNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const interaction = props.interaction as IGetTimerTime;
  const variables = useSelector(selectSequenceVariables);
  const { updateInteraction } = useUpdateSequenceInteraction();

  return (
    <div className="w-full h-full flex flex-col gap-[12px]">
      <VariableSelector
        variables={variables}
        selectedVariableId={interaction.storeDataKey}
        label="Store Data Key"
        filterByType={VariableType.Number}
        includeBuiltIns={false}
        onSelect={(storeDataKey) =>
          updateInteraction(props.nodeId, {
            ...interaction,
            storeDataKey,
          } as IGetTimerTime)
        }
      />
    </div>
  );
}
